// extracted by mini-css-extract-plugin
export default {"title":"ConsentItem_title__YrvrR","titleWithdrawn":"ConsentItem_titleWithdrawn__dFDkK","date":"ConsentItem_date__F6T5a","container":"ConsentItem_container__GGSEy"};